import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { deleteProcedureByUser } from './delete_procedure_logic';
import { NotificationManager } from 'react-notifications';

const DeleteProcedure = (props) => {
  const [showModal, setShowModal] = useState(false);

  const deleteAction = async (el) => {
    let response = await deleteProcedureByUser(el, props.props.history);
    setShowModal(false);

    if (
      typeof response.data.data.data.message == 'string' &&
      response.data.data.data.message !== ''
    ) {
      NotificationManager.success(response.data.data.data.message);
      window.location.reload();
    }
  };

  return (
    <>
      <Modal size="md" show={showModal} aria-labelledby="example-modal-sizes-title-sm">
        <Modal.Header className={'bg-complement-3'}>
          <Modal.Title id="example-modal-sizes-title-sm">Advertencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Esta seguro de eliminar este elemento?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
          <Button variant="danger" onClick={() => deleteAction(props.el)}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="trash" onClick={() => setShowModal(true)}>
        <i className="ti-trash" title="Eliminar" />
      </div>
    </>
  );
};

export default DeleteProcedure;
